
export default {

  methods: {

    set_LocalValues(){
      
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.rawData.sort((a, b) => a.A_TOT - b.A_TOT)

      this.sysData = JSON.parse(JSON.stringify(this.Queries.SQL1))
      this.sysData.forEach(d=> {
        d.SYS_CODE = d.SYS.substr(0,2)
        d.SYS_DESC = d.SYS_DESC.split(' - ')[1]
      })

      this.subSysData = JSON.parse(JSON.stringify(this.Queries.SQL2))
      this.subSysData.forEach(d=> {
        d.SYS_CODE = d.SYS.substr(0,2)
        d.DESC = d.SUBSYS_DESC.split(' - ')[1]
      })

      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title    = json.title
      this.pie      = json.pie
      this.detail   = json.detail
      this.handover = json.handover
      this.system   = json.system
      this.subsys   = json.subsys
      this.scroll   = json.scroll
      this.sundries = json.sundries
      this.keys     = json.keys
      this.filters  = json.filters


      // Scroll Bar
      this.scroll.viewbox = {...json.scroll.viewbox,
        space: null,
        y: this.system.y + 61,
      }
      this.scroll.bar = {...json.scroll.bar,
        y: 0,
        size: null,
        ratio: null,
        space: null,
        height: this.scroll.viewbox.height,
      }
      this.scroll.content = {
        y: 0,
        height: null,
      }

      this.current = {group: '99', sys: '9901'}


      // MCC
      this.mcc = {
        total:  this.rawData.map(d => d.SUBSYS_TOT).reduce((a, b) => (a + b)),
        actual: this.rawData.map(d => d.SUBSYS_ACT).reduce((a, b) => (a + b)),
        remain: this.rawData.map(d => d.SUBSYS_REM).reduce((a, b) => (a + b)),
      }
      this.mcc.prog = this.mcc.actual == 0 ? 0 : Number(((this.mcc.actual / this.mcc.total) *100).toFixed(1))

      // ITR A
      this.itrA = {
        total:  this.rawData.map(d => d.A_TOT).reduce((a, b) => (a + b)),
        actual: this.rawData.map(d => d.A_ACT).reduce((a, b) => (a + b)),
        remain: this.rawData.map(d => d.A_REM).reduce((a, b) => (a + b)),
      }
      this.itrA.prog = this.itrA.actual == 0 ? 0 : Number(((this.itrA.actual / this.itrA.total) *100).toFixed(1))

      // Punch A
      this.punchA = {
        total:  this.rawData.map(d => d.PA_TOT).reduce((a, b) => (a + b)),
        closed: this.rawData.map(d => d.PA_ACT).reduce((a, b) => (a + b)),
        active: this.rawData.map(d => d.PA_REM).reduce((a, b) => (a + b)),
      }
      this.punchA.prog = this.punchA.closed == 0 ? 0 : Number(((this.punchA.closed / this.punchA.total) *100).toFixed(1))
    },


    set_ScrollValues() {
      // Scroll Pre-Proceassing
      this.scroll.bar.size = this.scroll.viewbox.height / this.scroll.content.height * this.scroll.viewbox.height
      this.scroll.viewbox.space = this.scroll.content.height - this.scroll.viewbox.height
      this.scroll.bar.space = this.scroll.viewbox.height - this.scroll.bar.size

      this.draw_Scrollbar()
    },


  }
}